import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import logo from './Asset/logo.webp';
import atto from './Asset/menu-atto-3-rev2 (1).webp';
import m6 from './Asset/menu-m6 (1).webp';
import seal from './Asset/menu-seal (1).webp';
import bydsealion7 from './Asset/NAV_BYD_SEALION_7.webp';
import denzad9 from './Asset/danza-d9-header.webp';
import z9gt from './Asset/z9gt-header.png';
import atto2 from './Asset/atto2-header.png';
import ti7 from './Asset/ti7-header.png';
import seagull from './Asset/seagull.webp';
import m6dm from './images/bydm6dm/menu-1.webp';
import { Helmet } from 'react-helmet-async';

function Header() {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleLogoClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate('/');
  };

  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const navItems = [
    { label: 'MODEL', path: '/', hasDropdown: true },
    { label: 'TENTANG BYD', path: '/about-byd' },
    { label: 'HUBUNGI', path: '/contact' },
    { label: 'FLEET', path: '/fleet' },
    { label: 'WARRANTY', path: '/warranty' },
    { label: 'HARGA MOBIL BYD', path: '/pricing' },
    { label: 'GALLERY', path: '/gallery' },
    { label: 'BLOG', path: '/blog' },
  ];

  const models = [
    { name: 'BYD TI7', image: ti7, path: '/jelajahi-ti7', isPreBook: true },
    { name: 'BYD ATTO 2', image: atto2, path: '/jelajahi-atto2', isPreBook: true },
    { name: 'BYD M6 DM', image: m6dm, path: '/jelajahi-m6-dm', isHot: true },
    { name: 'DANZA Z9 GT', image: z9gt, path: '/jelajahi-z9gt', isHot: true },
    { name: 'BYD ATTO 1', image: seagull, path: '/jelajahi-atto1' },
    { name: 'BYD DANZA D9', image: denzad9, path: '/jelajahi-denzad9' },
    { name: 'BYD SEALION 7', image: bydsealion7, path: '/jelajahi-sealion-7' },
    { name: 'BYD SEAL', image: seal, path: '/jelajahi-seal' },
    { name: 'BYD ATTO 3', image: atto, path: '/jelajahi-atto' },
    { name: 'BYD M6', image: m6, path: '/jelajahi-m6' },
  ];

  return (
    <>
      <Helmet>
        <script type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            url: 'https://bydbsdserpong.com',
            logo: 'https://bydbsdserpong.com/static/media/logo.2a151e9e6824f6e000cd.webp',
          })}
        </script>
      </Helmet>
      <AppBar
        position='fixed'
        sx={{
          backgroundColor: '#252728',
          padding: { xs: '10px 15px', sm: '10px 30px' },
          boxSizing: 'border-box',
          zIndex: 1000,
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: { xs: 1, sm: 2 },
          }}
        >
          {/* Logo Section */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexShrink: 0,
              cursor: 'pointer',
            }}
            onClick={handleLogoClick}
          >
            <img
              src={logo}
              alt='Logo Dealer Mobil Listrik BYD BSD Serpong'
              style={{ width: '100px', height: 'auto' }}
            />
          </Box>

          {/* Desktop Navigation */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'center',
              flexGrow: 1,
              gap: { sm: 2, md: 3.5, lg: 5 },
            }}
          >
            {navItems.map((item, index) => (
              <Typography
                key={index}
                component='nav'
                onClick={() => {
                  if (!item.hasDropdown) navigate(item.path);
                }}
                onMouseEnter={item.hasDropdown ? handleMenuOpen : null}
                sx={{
                  color: '#fff',
                  fontSize: { sm: '12px', md: '14px', lg: '16px' },
                  fontWeight: 600,
                  lineHeight: 1.375,
                  cursor: 'pointer',
                  borderBottom: '2px solid transparent',
                  textAlign: 'center',
                  '&:hover': {
                    borderBottom: '2px solid #fff',
                  },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Box>

          {/* Mobile Menu Icon */}
          <IconButton
            color='inherit'
            edge='end'
            onClick={toggleDrawer}
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Dropdown Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        MenuListProps={{ onMouseLeave: handleMenuClose }}
        sx={{
          '& .MuiPaper-root': {
            backgroundColor: '#252728',
            color: '#fff',
            padding: 2,
          },
        }}
      >
        {models.map((model, idx) => (
          <MenuItem
            key={idx}
            onClick={() => {
              handleMenuClose();
              navigate(model.path);
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <img
              src={model.image}
              alt={model.name}
              loading='lazy'
              style={{
                width: '50px',
                height: 'auto',
                transform:
                  model.name === 'BYD DANZA D9' ? 'scaleX(-1)' : 'none',
              }}
            />
            <Typography>{model.name}</Typography>
            {model.isHot && <HotBadge />}
            {model.isPreBook && <PreBookBadge />}
          </MenuItem>
        ))}
      </Menu>

      {/* Drawer for Mobile Navigation */}
      <Drawer
        anchor='right'
        open={mobileOpen}
        onClose={toggleDrawer}
        sx={{
          '& .MuiDrawer-paper': {
            backgroundColor: '#252728',
            color: '#fff',
          },
        }}
      >
        <List>
          <ListItem>
            <Typography variant='body1' fontWeight='bold'>
              MODEL
            </Typography>
          </ListItem>
          {models.map((model, idx) => (
            <ListItem
              button
              key={idx}
              onClick={() => {
                toggleDrawer();
                navigate(model.path);
              }}
              sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
            >
              <img
                src={model.image}
                alt={model.name}
                style={{ width: '50px', height: 'auto' }}
              />
              <ListItemText
                primary={model.name}
                sx={{
                  '& span': {
                    fontSize: '16px',
                    fontWeight: 600,
                  },
                }}
              />
              {model.isHot && <HotBadge />}
              {model.isPreBook && <PreBookBadge />}
            </ListItem>
          ))}
          <Divider sx={{ my: 2, backgroundColor: '#fff' }} />
          {navItems.slice(1).map((item, idx) => (
            <ListItem
              button
              key={idx}
              onClick={() => {
                toggleDrawer();
                navigate(item.path);
              }}
            >
              <ListItemText
                primary={item.label}
                sx={{
                  textAlign: 'center',
                  '& span': {
                    fontSize: '16px',
                    fontWeight: 600,
                  },
                }}
              />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}

function PreBookBadge() {
  return (
    <Box
      component='span'
      sx={{
        px: 0.8,
        py: 0.2,
        borderRadius: '4px',
        backgroundColor: '#d4af37',
        color: '#1a1400',
        fontSize: 11,
        fontWeight: 900,
        letterSpacing: 0.3,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        boxShadow: '0 0 8px rgba(212,175,55,0.55)',
      }}
    >
      PRE-BOOK
    </Box>
  );
}

function HotBadge() {
  return (
    <Box
      component='span'
      sx={{
        px: 0.8,
        py: 0.2,
        borderRadius: '4px',
        backgroundColor: '#e53935',
        color: '#fff',
        fontSize: 11,
        fontWeight: 900,
        letterSpacing: 0.3,
        lineHeight: 1.4,
        boxShadow: '0 0 8px rgba(229,57,53,0.55)',
      }}
    >
      HOT
    </Box>
  );
}

export default Header;
